module.exports = __webpack_public_path__ + "media/images/flags/4x3/syc-0ae428cea90ba6de074c9130e5c2136f.svg";